
class exports.TraitSupplier

    constructor: ->
        @id = null
        @name = ''
        @is_real = true
